// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1j1Hc","options":"AnswerScale_options__2SPmj","selected":"AnswerScale_selected__ilWOJ"};